<template>
  <v-pagination
    outlined
    :style="`background: ${$theme.background};`"
    :color="$theme.primary"
    total-visible="7"
    v-model="get_invoices_filtros.page"
    :length="get_invoices.totalPages"
    @input="setPage($event)"
  ></v-pagination>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["get_invoices", "get_invoices_filtros"])
  },
  methods: {
    ...mapActions(["listar_invoices"]),
    setPage(page) {
      if (page) {
        console.log("page", page);
        this.get_invoices_filtros.page = page;
        this.listar_invoices();
      }
    }
  }
};
</script>
